// Delete file when cleaning up deliveroo_compal_a11y_fixes
import { defineMessages } from '@atlassian/jira-intl';

export const messages: {
	rightChevronLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	rightChevronLabel: {
		id: 'command-palette.common.components.command-row.right-content.right-chevron-label',
		defaultMessage: 'Command with children icon',
		description: 'Right chevron icon to indicate command has children',
	},
});
